import { useAppDispatch, useAppSelector } from "@/hooks/redux-hooks";
import { PATH_LOGIN } from "@/routes/paths";
import { logout } from "@/store/reducers/auth.reducer";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { DeleteConfirmationModal } from "@/components/DeleteConfirmationModal"; 
const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useAppSelector((s) => s.auth);  
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleConfirm = async () => {
    setIsLoggingOut(true);
    await dispatch(logout());
    setIsLoggingOut(false);
  };

  const handleClose = () => {
    navigate(-1);
  };

  if (!isLoggedIn) return <Navigate to={PATH_LOGIN} replace />;

  return (
    <DeleteConfirmationModal
      open={true}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Are you sure you want to logout?"
      confirmButtonText="Yes, Logout"
      isDeleting={isLoggingOut}
    />
  );
};

export default Logout;
